import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GiqCommonModule } from '../../common/common-module';
import { ChartsModule } from '../../charts/charts.module';

import { HighlightComponent } from './highlight/highlight.component';
import { ImageHighlightComponent } from './highlight/image/image-highlight.component';
import { SplitTextHighlightComponent } from './highlight/split-text/split-text-highlight.component';
import { MapHighlightComponent } from './highlight/map/map-highlight.component';
import { SalesScrollHighlightComponent } from './highlight/sales-scroll/sales-scroll-highlight.component';
import { TubesHighlightComponent } from './highlight/tubes/tubes-highlight.component';
import { AreaHighlightComponent } from './highlight/area/area-highlight.component';
import { DonutHighlightComponent } from './highlight/donut/donut-highlight.component';
import { LineHighlightComponent } from './highlight/line/line-highlight.component';
import { DualHighlightComponent } from './highlight/dual/dual-highlight.component';
import { ComplexDonutHighlightComponent } from './highlight/complex-donut/complex-donut-highlight.component';
import { BarsHighlightComponent } from './highlight/bars/bars-highlight.component';
import { ScatterplotHighlightComponent } from './highlight/scatterplot/scatterplot-highlight.component';
import { HorizontalBarChartComponent } from './highlight/horizontal-bar/horizontal-bar-highlight.component';
import { SectorHighlightComponent } from './highlight/sector/sector-highlight.component';
import { VerticalBarHighlightComponent } from './highlight/vertical-bar/vertical-bar-highlight.component';
import { LineOverBarsHighlightComponent } from './highlight/line-over-bars/line-over-bars-highlight.component';

/**
 * Shared module for all highlight chart components.
 * Imported by AppModule (for the home page highlights widget)
 * and by EditHighlightsModule (for the /highlights edit page).
 */
@NgModule({
  declarations: [
    HighlightComponent,
    ImageHighlightComponent,
    SplitTextHighlightComponent,
    MapHighlightComponent,
    SalesScrollHighlightComponent,
    TubesHighlightComponent,
    AreaHighlightComponent,
    DonutHighlightComponent,
    LineHighlightComponent,
    DualHighlightComponent,
    ComplexDonutHighlightComponent,
    BarsHighlightComponent,
    ScatterplotHighlightComponent,
    HorizontalBarChartComponent,
    SectorHighlightComponent,
    VerticalBarHighlightComponent,
    LineOverBarsHighlightComponent,
  ],
  imports: [
    CommonModule,
    GiqCommonModule,
    ChartsModule,
  ],
  exports: [
    HighlightComponent,
    ImageHighlightComponent,
    SplitTextHighlightComponent,
    MapHighlightComponent,
    SalesScrollHighlightComponent,
    TubesHighlightComponent,
    AreaHighlightComponent,
    DonutHighlightComponent,
    LineHighlightComponent,
    DualHighlightComponent,
    ComplexDonutHighlightComponent,
    BarsHighlightComponent,
    ScatterplotHighlightComponent,
    HorizontalBarChartComponent,
    SectorHighlightComponent,
    VerticalBarHighlightComponent,
    LineOverBarsHighlightComponent,
  ],
})
export class HighlightsSharedModule {}
